// src/mixins/scriptMixin.js

export default {
  methods: {
    addScript(src, id) {
      if (!document.getElementById(id)) {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.id = id;
        document.head.appendChild(script);
      }
    },
    addInlineScript(content, id) {
      if (!document.getElementById(id)) {
        const script = document.createElement('script');
        script.innerHTML = content;
        script.id = id;
        document.head.appendChild(script);
      }
    },
    addNoScript(src, id) {
      if (!document.getElementById(id)) {
        const noscript = document.createElement('noscript');
        const img = document.createElement('img');
        img.src = src;
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        noscript.appendChild(img);
        noscript.id = id;
        document.body.appendChild(noscript);
      }
    },
    loadTrackingScripts() {
      // Google Ads
      this.addScript('https://www.googletagmanager.com/gtag/js?id=AW-383921375', 'google-tag');
      this.addInlineScript(`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-383921375');
      `, 'google-inline-tag');

      // Meta Pixel
      this.addInlineScript(`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1120372455132381');
        fbq('track', 'Page_View');
      `, 'meta-pixel-inline');
      this.addNoScript('https://www.facebook.com/tr?id=1120372455132381&ev=PageView&noscript=1', 'meta-pixel-noscript');

      // TikTok
      this.addInlineScript(`
        !function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
          ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],
          ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
          for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
          ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},
          ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";
          ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,
          ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");
          o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;
          var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
          ttq.load('CRU42MRC77U3OBONCUO0');
          ttq.page();
        }(window, document, 'ttq');
      `, 'tiktok-pixel-inline');

      // LinkedIn
      this.addInlineScript(`
        _linkedin_partner_id = "4147593";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      `, 'linkedin-pixel-inline');
      this.addScript('https://snap.licdn.com/li.lms-analytics/insight.min.js', 'linkedin-tag');

      this.addNoScript('https://px.ads.linkedin.com/collect/?pid=4147593&fmt=gif', 'linkedin-noscript');
    }
  }
}
